/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoCreateFlightCompany } from '../../models/dto-create-flight-company';
import { FlightCompany } from '../../models/flight-company';

export interface CommonControllerUpdateFlightCompany$Params {
  code: string;
      body: DtoCreateFlightCompany
}

export function commonControllerUpdateFlightCompany(http: HttpClient, rootUrl: string, params: CommonControllerUpdateFlightCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerUpdateFlightCompany.PATH, 'patch');
  if (params) {
    rb.path('code', params.code, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: FlightCompany;
      }>;
    })
  );
}

commonControllerUpdateFlightCompany.PATH = '/common/flight-companies/{code}';
